import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './Auth/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';

// Routes intentionally excluded from demo mode (e.g. a feature too heavy/unsafe to mock,
// like a real backend job). Add a path prefix here instead of mocking it in demoStore.js.
// See CLAUDE.md "Demo mode" section for when to use this vs. adding a mock.
const DEMO_UNSUPPORTED_ROUTES = [];

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, user, isDemoMode } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!isDemoMode && (!isLoggedIn || !user)) {
    return <Navigate to="/login" replace />;
  }

  if (isDemoMode && DEMO_UNSUPPORTED_ROUTES.some((r) => location.pathname.startsWith(r))) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        textAlign="center"
        px={2}
        gap={1}
      >
        <Typography variant="h6">This page isn't available in demo mode yet</Typography>
        <Typography variant="body2" color="text.secondary">
          Sign up for free to access this feature.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;